<!-- Mobile/tablet backdrop overlay (below lg) - click to close the drawer. Desktop never renders this. -->
<div *ngIf="isMobileOpen()" (click)="closeMobileSidebar()" class="fixed inset-0 z-30 bg-gray-900/50 lg:hidden"
   aria-hidden="true"></div>

<aside id="logo-sidebar"
   class="fixed left-0 z-40 w-72 max-w-[85vw] lg:w-64 top-[var(--navbar-height,5rem)] h-[calc(100vh-var(--navbar-height,5rem))] transition-transform duration-300 ease-in-out lg:translate-x-0 bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700"
   [class.translate-x-0]="isMobileOpen()" [class.-translate-x-full]="!isMobileOpen()"
   aria-label="Sidebar">
   <button type="button" (click)="closeMobileSidebar()"
      class="absolute top-2 right-2 z-10 inline-flex items-center justify-center rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900 lg:hidden"
      aria-label="Close sidebar">
      <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
         <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M6 18 18 6M6 6l12 12" />
      </svg>
   </button>
   <div class="h-full px-3 pb-4 overflow-y-auto bg-white dark:bg-gray-800">
      <ul class="space-y-1 font-medium">
         <li>
            <a routerLinkActive="active-link" [routerLink]="['/tokenomics']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M8.64 4.737A7.97 7.97 0 0 1 12 4a7.997 7.997 0 0 1 6.933 4.006h-.738c-.65 0-1.177.25-1.177.9 0 .33 0 2.04-2.026 2.008-1.972 0-1.972-1.732-1.972-2.008 0-1.429-.787-1.65-1.752-1.923-.374-.105-.774-.218-1.166-.411-1.004-.497-1.347-1.183-1.461-1.835ZM6 4a10.06 10.06 0 0 0-2.812 3.27A9.956 9.956 0 0 0 2 12c0 5.289 4.106 9.619 9.304 9.976l.054.004a10.12 10.12 0 0 0 1.155.007h.002a10.024 10.024 0 0 0 1.5-.19 9.925 9.925 0 0 0 2.259-.754 10.041 10.041 0 0 0 4.987-5.263A9.917 9.917 0 0 0 22 12a10.025 10.025 0 0 0-.315-2.5A10.001 10.001 0 0 0 12 2a9.964 9.964 0 0 0-6 2Zm13.372 11.113a2.575 2.575 0 0 0-.75-.112h-.217A3.405 3.405 0 0 0 15 18.405v1.014a8.027 8.027 0 0 0 4.372-4.307ZM12.114 20H12A8 8 0 0 1 5.1 7.95c.95.541 1.421 1.537 1.835 2.415.209.441.403.853.637 1.162.54.712 1.063 1.019 1.591 1.328.52.305 1.047.613 1.6 1.316 1.44 1.825 1.419 4.366 1.35 5.828Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Tokenomics</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/distribution-plan']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M9 2a1 1 0 0 0-1 1H6a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2a1 1 0 0 0-1-1H9Zm1 2h4v2h1a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2h1V4Zm5.707 8.707a1 1 0 0 0-1.414-1.414L11 14.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Distribution Plan</span>
            </a>
         </li>

         <!-- <li>
            <a routerLinkActive="active-link" [routerLink]="['/final-regular-distribution-plan']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M9 2a1 1 0 0 0-1 1H6a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2a1 1 0 0 0-1-1H9Zm1 2h4v2h1a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2h1V4Zm5.707 8.707a1 1 0 0 0-1.414-1.414L11 14.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">AOC BEP20 Final Regular Distribution Plan</span>
            </a>
         </li> -->

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/distribution-execution']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="none" viewBox="0 0 24 24">
                     <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 15v4m6-6v6m6-4v4m6-6v6M3 11l6-5 6 5 5.5-5.5" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Distribution Execution</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/global-final-distribution-execution']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="none" viewBox="0 0 24 24">
                     <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 15v4m6-6v6m6-4v4m6-6v6M3 11l6-5 6 5 5.5-5.5" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Global Final Distribution Execution</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" href={{auditReportLink}} target="_blank"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="none" viewBox="0 0 24 24">
                     <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 7h1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h11.5M7 14h6m-6 3h6m0-10h.5m-.5 3h.5M7 7h3v3H7V7Z" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Audit Report</span>
            </a>
         </li>

         <li>
            <button (click)="toggleDistributionUserMenu()" [ngClass]="isDistributionUserMenuOpen ? 'bg-gray-100' : ''"
               class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg hover:bg-gray-100 justify-between">
               <div class="flex items-center min-w-0">
                  <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                     <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="currentColor" viewBox="0 0 24 24">
                        <path
                           d="M12 7.205c4.418 0 8-1.165 8-2.602C20 3.165 16.418 2 12 2S4 3.165 4 4.603c0 1.437 3.582 2.602 8 2.602ZM12 22c4.963 0 8-1.686 8-2.603v-4.404c-.052.032-.112.06-.165.09a7.75 7.75 0 0 1-.745.387c-.193.088-.394.173-.6.253-.063.024-.124.05-.189.073a18.934 18.934 0 0 1-6.3.998c-2.135.027-4.26-.31-6.3-.998-.065-.024-.126-.05-.189-.073a10.143 10.143 0 0 1-.852-.373 7.75 7.75 0 0 1-.493-.267c-.053-.03-.113-.058-.165-.09v4.404C4 20.315 7.037 22 12 22Zm7.09-13.928a9.91 9.91 0 0 1-.6.253c-.063.025-.124.05-.189.074a18.935 18.935 0 0 1-6.3.998c-2.135.027-4.26-.31-6.3-.998-.065-.024-.126-.05-.189-.074a10.163 10.163 0 0 1-.852-.372 7.816 7.816 0 0 1-.493-.268c-.055-.03-.115-.058-.167-.09V12c0 .917 3.037 2.603 8 2.603s8-1.686 8-2.603V7.596c-.052.031-.112.059-.165.09a7.816 7.816 0 0 1-.745.386Z" />
                     </svg>
                  </span>
                  <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Distribution User Data</span>
               </div>
               <svg [class.rotate-180]="isDistributionUserMenuOpen"
                  class="w-4 h-4 shrink-0 transition-transform duration-200 text-gray-500" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
               </svg>
            </button>
            <ul *ngIf="isDistributionUserMenuOpen" class="relative mt-1 ml-4 space-y-1 border-l border-gray-200 pl-3">
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/distribution-user-data/web3']"
                     class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     <svg class="w-4 h-4 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20"
                        height="20" fill="currentColor" viewBox="0 0 24 24">
                        <path
                           d="M12.4472 2.10557c-.2815-.14076-.6129-.14076-.8944 0L5.90482 4.92956l.37762.11119c.01131.00333.02257.00687.03376.0106L12 6.94594l5.6808-1.89361.3927-.13363-5.6263-2.81313ZM5 10V6.74803l.70053.20628L7 7.38747V10c0 .5523-.44772 1-1 1s-1-.4477-1-1Zm3-1c0-.42413.06601-.83285.18832-1.21643l3.49538 1.16514c.2053.06842.4272.06842.6325 0l3.4955-1.16514C15.934 8.16715 16 8.57587 16 9c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4Z" />
                        <path
                           d="M14.2996 13.2767c.2332-.2289.5636-.3294.8847-.2692C17.379 13.4191 19 15.4884 19 17.6488v2.1525c0 1.2289-1.0315 2.1428-2.2 2.1428H7.2c-1.16849 0-2.2-.9139-2.2-2.1428v-2.1525c0-2.1409 1.59079-4.1893 3.75163-4.6288.32214-.0655.65589.0315.89274.2595l2.34883 2.2606 2.3064-2.2634Z" />
                     </svg>
                     <span>Web3 Users</span>
                  </a>
               </li>
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/distribution-user-data/web2']"
                     class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     <svg class="w-4 h-4 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20"
                        height="20" fill="currentColor" viewBox="0 0 24 24">
                        <path fill-rule="evenodd"
                           d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z"
                           clip-rule="evenodd" />
                     </svg>
                     <span>Web2 Users</span>
                  </a>
               </li>
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/all-distribution-user-data']"
                     class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     <svg class="w-4 h-4 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20"
                        height="20" fill="currentColor" viewBox="0 0 24 24">
                        <path fill-rule="evenodd"
                           d="M12 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-1.5 8a4 4 0 0 0-4 4 2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-3Zm6.82-3.096a5.51 5.51 0 0 0-2.797-6.293 3.5 3.5 0 1 1 2.796 6.292ZM19.5 18h.5a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-1.1a5.503 5.503 0 0 1-.471.762A5.998 5.998 0 0 1 19.5 18ZM4 7.5a3.5 3.5 0 0 1 5.477-2.889 5.5 5.5 0 0 0-2.796 6.293A3.501 3.501 0 0 1 4 7.5ZM7.1 12H6a4 4 0 0 0-4 4 2 2 0 0 0 2 2h.5a5.998 5.998 0 0 1 3.071-5.238A5.505 5.505 0 0 1 7.1 12Z"
                           clip-rule="evenodd" />
                     </svg>
                     <span>All Users</span>
                  </a>
               </li>
            </ul>
         </li>

         <li>
            <button (click)="toggleTokenDistributionMenu()" [ngClass]="showTokenYears ? 'bg-gray-100' : ''"
               class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg hover:bg-gray-100 justify-between">
               <div class="flex items-center min-w-0">
                  <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                     <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" viewBox="0 0 24 24">
                        <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
                        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                     </svg>
                  </span>
                  <span class="ms-3 flex-1 min-w-0 text-left leading-snug">AOC BEP20 V2.1 Primitive Regular
                     Distribution</span>
               </div>
               <svg [class.rotate-180]="showTokenYears"
                  class="w-4 h-4 shrink-0 transition-transform duration-200 text-gray-500" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
               </svg>
            </button>

            <ul *ngIf="showTokenYears" class="mt-1 ml-4 space-y-1 border-l border-gray-200 pl-3">
               <li *ngFor="let year of tokenYears; let i = index;">
                  <button (click)="selectTokenYear(i, year.year)"
                     [ngClass]="selectedTokenYearIndex === i ? 'bg-gray-100' : ''"
                     class="flex items-center w-full rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span>Year {{ year.year }}</span>
                     <svg [class.rotate-180]="selectedTokenYearIndex === i"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                        </path>
                     </svg>
                  </button>

                  <ul *ngIf="selectedTokenYearIndex === i" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li *ngFor="let month of year.months">
                        <a routerLinkActive="active-link" (click)="yearSelected()"
                           [routerLink]="['/token-distribution-details', year.year, month.no]"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           {{ month.month }}
                        </a>
                     </li>
                  </ul>
               </li>
            </ul>
         </li>

         <li>
            <!-- AOC BEP20 V2.1 Web3 Final Distribution Data Menu -->
            <button (click)="toggleFinalDistributionMenu()" [ngClass]="showFinalDistributionMenu ? 'bg-gray-100' : ''"
               class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg hover:bg-gray-100 justify-between">
               <div class="flex items-center min-w-0">
                  <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                     <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="currentColor" viewBox="0 0 24 24">
                        <path fill-rule="evenodd"
                           d="M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z"
                           clip-rule="evenodd" />
                     </svg>
                  </span>
                  <span class="ms-3 flex-1 min-w-0 text-left leading-snug">AOC BEP20 V2.1 Web3 Final Distribution
                     Data</span>
               </div>
               <svg [class.rotate-180]="showFinalDistributionMenu"
                  class="w-4 h-4 shrink-0 transition-transform duration-200 text-gray-500" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
               </svg>
            </button>

            <ul *ngIf="showFinalDistributionMenu" class="relative mt-1 ml-4 space-y-1 border-l border-gray-200 pl-3">
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/final-distribution', 'rapture']"
                     class="block rounded-lg px-3 py-2 text-sm text-gray-700 leading-snug transition duration-75 hover:bg-gray-100">
                     Rapture Regular Distribution
                  </a>
               </li>
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/final-distribution', 'initiative-54']"
                     class="block rounded-lg px-3 py-2 text-sm text-gray-700 leading-snug transition duration-75 hover:bg-gray-100">
                     Initiative 54: ÉWLIZO MAVƆMAVƆ AVÍVI
                  </a>
               </li>

               <li>
                  <button (click)="toggleFinalDistributionAMCMenu()"
                     [ngClass]="showFinalDistributionAMCMenu ? 'bg-gray-100' : ''"
                     class="flex items-center w-full gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span class="flex-1 min-w-0 text-left leading-snug">Aggressive Marketing Campaigns – Resurrection
                        Season Initiatives</span>
                     <svg [class.rotate-180]="showFinalDistributionAMCMenu" class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                     </svg>
                  </button>
                  <ul *ngIf="showFinalDistributionAMCMenu" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'amc-campaigns', 'initiative-55']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Initiative 55
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'amc-campaigns', 'initiative-63']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Initiative 63
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'amc-campaigns', 'initiative-64']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Initiative 64
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'amc-campaigns', 'amc-global']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Global AMC Users
                        </a>
                     </li>
                  </ul>
               </li>

               <li>
                  <button (click)="toggleFinalDistributionSAFMenu()"
                     [ngClass]="showFinalDistributionSAFMenu ? 'bg-gray-100' : ''"
                     class="flex items-center w-full gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span class="flex-1 min-w-0 text-left leading-snug">SAF-AOC Initiatives</span>
                     <svg [class.rotate-180]="showFinalDistributionSAFMenu"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                     </svg>
                  </button>
                  <ul *ngIf="showFinalDistributionSAFMenu" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'saf-initiatives', 'initiative-57']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Initiative 57
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'saf-initiatives', 'initiative-59']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Initiative 59
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'saf-initiatives', 'initiative-60']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Initiative 60
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'saf-initiatives', 'initiative-61']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Initiative 61
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link"
                           [routerLink]="['/final-distribution', 'saf-initiatives', 'saf-global']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           Global SAF Users
                        </a>
                     </li>
                  </ul>
               </li>
            </ul>
         </li>
         <li>
            <a routerLinkActive="active-link" [routerLink]="['/raptured-final-distribution']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">AOC BEP20 V2.1 Web2 Raptured Final Distribution
                  Data</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/final-distribution-synoptic', 'synoptic-global']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Synoptic (Web3+Web2) Final Distribution Data</span>
            </a>
         </li>

         <li>
            <button (click)="toggleGlobalTokenDistributionMenu()" [ngClass]="showGlobalTokenYears ? 'bg-gray-100' : ''"
               class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg hover:bg-gray-100 justify-between">
               <div class="flex items-center min-w-0">
                  <span
                     class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                     <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path
                           d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                        </path>
                     </svg>
                  </span>
                  <span class="ms-3 flex-1 min-w-0 text-left leading-snug">AOC BEP20 V2.1 Final Regular
                     Distribution</span>
               </div>
               <svg [class.rotate-180]="showGlobalTokenYears"
                  class="w-4 h-4 shrink-0 transition-transform duration-200 text-gray-500" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
               </svg>
            </button>

            <ul *ngIf="showGlobalTokenYears" class="mt-1 ml-4 space-y-1 border-l border-gray-200 pl-3">
               <li *ngFor="let year of globalTokenYears; let i = index;">
                  <button (click)="selectGlobalTokenYear(i)"
                     [ngClass]="selectedGlobalTokenYearIndex === i ? 'bg-gray-100' : ''"
                     class="flex items-center w-full rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span>Year {{ year.year }}</span>
                     <svg [class.rotate-180]="selectedGlobalTokenYearIndex === i"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                        </path>
                     </svg>
                  </button>

                  <ul *ngIf="selectedGlobalTokenYearIndex === i" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li *ngFor="let month of year.months">
                        <a routerLinkActive="active-link" (click)="yearSelected()"
                           [routerLink]="['/global-distribution-details', year.year, month.no]"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           {{ month.month }}
                        </a>
                     </li>
                  </ul>
               </li>
            </ul>
         </li>

         <!-- Aggressive Marketing campaign (AMC) menu - temporarily disabled
         <li>
            <button (click)="toogleAMCChampainMenu()" [ngClass]="showAMCTokenDistributionMenu ? 'bg-gray-100' : ''"
               class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg hover:bg-gray-100 justify-between">
               <div class="flex items-center min-w-0">
                  <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                     <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                           d="m10.051 8.102-3.778.322-1.994 1.994a.94.94 0 0 0 .533 1.6l2.698.316m8.39 1.617-.322 3.78-1.994 1.994a.94.94 0 0 1-1.595-.533l-.4-2.652m8.166-11.174a1.366 1.366 0 0 0-1.12-1.12c-1.616-.279-4.906-.623-6.38.853-1.671 1.672-5.211 8.015-6.31 10.023a.932.932 0 0 0 .162 1.111l.828.835.833.832a.932.932 0 0 0 1.111.163c2.008-1.102 8.35-4.642 10.021-6.312 1.475-1.478 1.133-4.77.855-6.385Zm-2.961 3.722a1.88 1.88 0 1 1-3.76 0 1.88 1.88 0 0 1 3.76 0Z" />
                     </svg>
                  </span>
                  <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Aggressive Marketing campaign</span>
               </div>
               <svg [class.rotate-180]="showAMCTokenDistributionMenu"
                  class="w-4 h-4 shrink-0 transition-transform duration-200 text-gray-500" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
               </svg>
            </button>
            <ul *ngIf="showAMCTokenDistributionMenu" class="mt-1 ml-4 space-y-1 border-l border-gray-200 pl-3">
               <li>
                  <button (click)="toggleAMCUserMenu()" [ngClass]="isAMCUserMenuOpen ? 'bg-gray-100' : ''"
                     class="flex items-center w-full gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span class="flex-1 min-w-0 text-left leading-snug">AMC Users</span>
                     <svg [class.rotate-180]="isAMCUserMenuOpen"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                     </svg>
                  </button>
                  <ul *ngIf="isAMCUserMenuOpen" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li>
                        <a routerLinkActive="active-link" [routerLink]="['/amc-user-data/web3']"
                           class="flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           <svg class="w-4 h-4 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                              width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                              <path
                                 d="M12.4472 2.10557c-.2815-.14076-.6129-.14076-.8944 0L5.90482 4.92956l.37762.11119c.01131.00333.02257.00687.03376.0106L12 6.94594l5.6808-1.89361.3927-.13363-5.6263-2.81313ZM5 10V6.74803l.70053.20628L7 7.38747V10c0 .5523-.44772 1-1 1s-1-.4477-1-1Zm3-1c0-.42413.06601-.83285.18832-1.21643l3.49538 1.16514c.2053.06842.4272.06842.6325 0l3.4955-1.16514C15.934 8.16715 16 8.57587 16 9c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4Z" />
                              <path
                                 d="M14.2996 13.2767c.2332-.2289.5636-.3294.8847-.2692C17.379 13.4191 19 15.4884 19 17.6488v2.1525c0 1.2289-1.0315 2.1428-2.2 2.1428H7.2c-1.16849 0-2.2-.9139-2.2-2.1428v-2.1525c0-2.1409 1.59079-4.1893 3.75163-4.6288.32214-.0655.65589.0315.89274.2595l2.34883 2.2606 2.3064-2.2634Z" />
                           </svg>
                           <span>Web3 AMC Users</span>
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link" [routerLink]="['/amc-user-data/web2']"
                           class="flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           <svg class="w-4 h-4 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                              width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                              <path fill-rule="evenodd"
                                 d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z"
                                 clip-rule="evenodd" />
                           </svg>
                           <span>Web2 AMC Users</span>
                        </a>
                     </li>
                     <li>
                        <a routerLinkActive="active-link" [routerLink]="['/amc-user-data/all']"
                           class="flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           <svg class="w-4 h-4 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                              width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                              <path fill-rule="evenodd"
                                 d="M12 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-1.5 8a4 4 0 0 0-4 4 2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-3Zm6.82-3.096a5.51 5.51 0 0 0-2.797-6.293 3.5 3.5 0 1 1 2.796 6.292ZM19.5 18h.5a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-1.1a5.503 5.503 0 0 1-.471.762A5.998 5.998 0 0 1 19.5 18ZM4 7.5a3.5 3.5 0 0 1 5.477-2.889 5.5 5.5 0 0 0-2.796 6.293A3.501 3.501 0 0 1 4 7.5ZM7.1 12H6a4 4 0 0 0-4 4 2 2 0 0 0 2 2h.5a5.998 5.998 0 0 1 3.071-5.238A5.505 5.505 0 0 1 7.1 12Z"
                                 clip-rule="evenodd" />
                           </svg>
                           <span>All AMC Users</span>
                        </a>
                     </li>
                  </ul>
               </li>

               <li>
                  <button (click)="toggleAMCTokenDistributionMenu()" [ngClass]="showAMCTokenYears ? 'bg-gray-100' : ''"
                     class="flex items-center w-full gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span class="flex-1 min-w-0 text-left leading-snug">AMC Token Distribution</span>
                     <svg [class.rotate-180]="showAMCTokenYears"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                     </svg>
                  </button>

                  <ul *ngIf="showAMCTokenYears" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li *ngFor="let year of amctokenYears; let i = index;">
                        <button (click)="selectAMCTokenYear(i, year.year)"
                           [ngClass]="selectedAMCTokenYearIndex === i ? 'bg-gray-100' : ''"
                           class="flex items-center w-full rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100 justify-between">
                           <span>Year {{ year.year }}</span>
                           <svg [class.rotate-180]="selectedAMCTokenYearIndex === i"
                              class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                              stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                              </path>
                           </svg>
                        </button>

                        <ul *ngIf="selectedAMCTokenYearIndex === i" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                           <li *ngFor="let month of year.months">
                              <a routerLinkActive="active-link" (click)="yearSelected()"
                                 [routerLink]="['/amc-token-distribution-details', year.year, month.no]"
                                 class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                                 {{ month.month }}
                              </a>
                           </li>
                        </ul>
                     </li>
                  </ul>
               </li>

               <li>
                  <button (click)="toggleAMCTokenDistributionHistoryMenu()"
                     [ngClass]="showAMCTokenYearsHistory ? 'bg-gray-100' : ''"
                     class="flex items-center text-start w-full gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span class="flex-1 min-w-0 text-left leading-snug">AMC Specific Distribution History</span>
                     <svg [class.rotate-180]="showAMCTokenYearsHistory"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                        </path>
                     </svg>
                  </button>

                  <ul *ngIf="showAMCTokenYearsHistory" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li *ngFor="let year of amctokenYears; let i = index;">
                        <button (click)="selectAMCTokenHistoryYear(i, year.year)"
                           [ngClass]="selectedAMCTokenHistoryYearIndex === i ? 'bg-gray-100' : ''"
                           class="flex items-center w-full rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100 justify-between">
                           <span>Year {{ year.year }}</span>
                           <svg [class.rotate-180]="selectedAMCTokenHistoryYearIndex === i"
                              class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                              stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                 d="M19 9l-7 7-7-7">
                              </path>
                           </svg>
                        </button>

                        <ul *ngIf="selectedAMCTokenHistoryYearIndex === i" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                           <li *ngFor="let month of year.months">
                              <a routerLinkActive="active-link" (click)="yearSelected()"
                                 [routerLink]="['/amc-token-distribution-history',year.year, month.no,'2']"
                                 class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                                 {{ month.month }}
                              </a>
                           </li>
                        </ul>
                     </li>
                  </ul>
               </li>

               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/amc-global-distribution-history']"
                     class="block rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     Global Distribution History
                  </a>
               </li>
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/amc-distribution-execution']"
                     class="block rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     AMC Distribution Execution
                  </a>
               </li>
            </ul>
         </li>
         -->

         <!-- SAF-AOC Distribution menu - temporarily disabled
         <li>
            <button (click)="toggleSAFDistributionMenu()" [ngClass]="showSAFDistributionMenu ? 'bg-gray-100' : ''"
               class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg hover:bg-gray-100 justify-between">
               <div class="flex items-center min-w-0">
                  <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                     <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="currentColor" viewBox="0 0 24 24">
                        <path fill-rule="evenodd"
                           d="M12 1a1 1 0 0 0-.3.05l-7 2.333A1 1 0 0 0 4 4.333V9c0 5.163 3.11 9.606 7.276 11.849a1 1 0 0 0 .448.151.999.999 0 0 0 .448-.151C16.34 18.606 19.45 14.163 19.45 9V4.333a1 1 0 0 0-.7-.95l-7-2.334A1 1 0 0 0 12 1Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L10.5 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"
                           clip-rule="evenodd" />
                     </svg>
                  </span>
                  <span class="ms-3 flex-1 min-w-0 text-left leading-snug">SAF-AOC Distribution</span>
               </div>
               <svg [class.rotate-180]="showSAFDistributionMenu"
                  class="w-4 h-4 shrink-0 transition-transform duration-200 text-gray-500" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
               </svg>
            </button>
            <ul *ngIf="showSAFDistributionMenu" class="mt-1 ml-4 space-y-1 border-l border-gray-200 pl-3">
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/saf-user-data']"
                     class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     <svg class="w-4 h-4 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20"
                        height="20" fill="currentColor" viewBox="0 0 24 24">
                        <path
                           d="M12.4472 2.10557c-.2815-.14076-.6129-.14076-.8944 0L5.90482 4.92956l.37762.11119c.01131.00333.02257.00687.03376.0106L12 6.94594l5.6808-1.89361.3927-.13363-5.6263-2.81313ZM5 10V6.74803l.70053.20628L7 7.38747V10c0 .5523-.44772 1-1 1s-1-.4477-1-1Zm3-1c0-.42413.06601-.83285.18832-1.21643l3.49538 1.16514c.2053.06842.4272.06842.6325 0l3.4955-1.16514C15.934 8.16715 16 8.57587 16 9c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4Z" />
                        <path
                           d="M14.2996 13.2767c.2332-.2289.5636-.3294.8847-.2692C17.379 13.4191 19 15.4884 19 17.6488v2.1525c0 1.2289-1.0315 2.1428-2.2 2.1428H7.2c-1.16849 0-2.2-.9139-2.2-2.1428v-2.1525c0-2.1409 1.59079-4.1893 3.75163-4.6288.32214-.0655.65589.0315.89274.2595l2.34883 2.2606 2.3064-2.2634Z" />
                     </svg>
                     <span>SAF-AOC Users</span>
                  </a>
               </li>

               <li>
                  <button (click)="toggleSAFTokenDistributionMenu()" [ngClass]="showSAFTokenYears ? 'bg-gray-100' : ''"
                     class="flex items-center w-full gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span class="flex-1 min-w-0 text-left leading-snug">SAF-AOC Token Distribution</span>
                     <svg [class.rotate-180]="showSAFTokenYears"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                     </svg>
                  </button>

                  <ul *ngIf="showSAFTokenYears" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li *ngFor="let year of safTokenYears; let i = index;">
                        <button (click)="selectSAFTokenYear(i)"
                           [ngClass]="selectedSAFTokenYearIndex === i ? 'bg-gray-100' : ''"
                           class="flex items-center w-full rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100 justify-between">
                           <span>Year {{ year.year }}</span>
                           <svg [class.rotate-180]="selectedSAFTokenYearIndex === i"
                              class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                              stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                              </path>
                           </svg>
                        </button>

                        <ul *ngIf="selectedSAFTokenYearIndex === i" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                           <li *ngFor="let month of year.months">
                              <a routerLinkActive="active-link" (click)="yearSelected()"
                                 [routerLink]="['/saf-token-distribution-details', year.year, month.no]"
                                 class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                                 {{ month.month }}
                              </a>
                           </li>
                        </ul>
                     </li>
                  </ul>
               </li>

               <li>
                  <button (click)="toggleSAFTokenDistributionHistoryMenu()"
                     [ngClass]="showSAFTokenYearsHistory ? 'bg-gray-100' : ''"
                     class="flex items-center text-start w-full gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span class="flex-1 min-w-0 text-left leading-snug">SAF-AOC Specific Distribution History</span>
                     <svg [class.rotate-180]="showSAFTokenYearsHistory"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                        </path>
                     </svg>
                  </button>

                  <ul *ngIf="showSAFTokenYearsHistory" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li *ngFor="let year of safTokenYears; let i = index;">
                        <button (click)="selectSAFTokenHistoryYear(i)"
                           [ngClass]="selectedSAFTokenHistoryYearIndex === i ? 'bg-gray-100' : ''"
                           class="flex items-center w-full rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100 justify-between">
                           <span>Year {{ year.year }}</span>
                           <svg [class.rotate-180]="selectedSAFTokenHistoryYearIndex === i"
                              class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                              stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                 d="M19 9l-7 7-7-7">
                              </path>
                           </svg>
                        </button>

                        <ul *ngIf="selectedSAFTokenHistoryYearIndex === i" class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                           <li *ngFor="let month of year.months">
                              <a routerLinkActive="active-link" (click)="yearSelected()"
                                 [routerLink]="['/saf-token-distribution-history',year.year, month.no,'2']"
                                 class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                                 {{ month.month }}
                              </a>
                           </li>
                        </ul>
                     </li>
                  </ul>
               </li>

               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/saf-global-distribution-history']"
                     class="block rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     SAF-AOC Global Distribution History
                  </a>
               </li>
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/saf-distribution-execution']"
                     class="block rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     SAF-AOC Distribution Execution
                  </a>
               </li>
            </ul>
         </li>
         -->

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/excess-distribution-data']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M7 6a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2v-4a3 3 0 0 0-3-3H7V6Z"
                        clip-rule="evenodd" />
                     <path fill-rule="evenodd"
                        d="M2 11a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7Zm7.5 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
                        clip-rule="evenodd" />
                     <path d="M10.5 14.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Excess distribution user data</span>
            </a>
         </li>

         <li>
            <button (click)="toggleTokenDistributionHistoryMenu()"
               [ngClass]="showTokenYearsHistory ? 'bg-gray-100' : ''"
               class="flex items-center text-start w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg hover:bg-gray-100 justify-between">
               <div class="flex items-center min-w-0">
                  <span
                     class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                     <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 10h16M8 14h8m-4-7V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z" />
                     </svg>
                  </span>
                  <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Specific Distribution History</span>
               </div>
               <svg [class.rotate-180]="showTokenYearsHistory"
                  class="w-4 h-4 shrink-0 transition-transform duration-200 text-gray-500" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
               </svg>
            </button>

            <ul *ngIf="showTokenYearsHistory" class="mt-1 ml-4 space-y-1 border-l border-gray-200 pl-3">
               <li *ngFor="let year of tokenYears; let i = index;">
                  <button (click)="selectTokenHistoryYear(i, year.year)"
                     [ngClass]="selectedTokenHistoryYearIndex === i ? 'bg-gray-100' : ''"
                     class="flex items-center w-full rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100 justify-between">
                     <span>Year {{ year.year }}</span>
                     <svg [class.rotate-180]="selectedTokenHistoryYearIndex === i"
                        class="w-3.5 h-3.5 shrink-0 transition-transform duration-200 text-gray-400" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                        </path>
                     </svg>
                  </button>

                  <ul *ngIf="selectedTokenHistoryYearIndex === i"
                     class="mt-1 ml-3 space-y-1 border-l border-gray-200 pl-3">
                     <li *ngFor="let month of year.months">
                        <a routerLinkActive="active-link" (click)="yearSelected()"
                           [routerLink]="['/token-distribution-history', year.year, month.no,'2']"
                           class="block rounded-lg px-3 py-1.5 text-sm text-gray-600 transition duration-75 hover:bg-gray-100">
                           {{ month.month }}
                        </a>
                     </li>
                  </ul>
               </li>
            </ul>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/global-distribution-history']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M6 2a2 2 0 0 0-2 2v15a3 3 0 0 0 3 3h12a1 1 0 1 0 0-2h-2v-2h2a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2h-8v16h5v2H7a1 1 0 1 1 0-2h1V2H6Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Global Distribution History</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/announcement']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M18.458 3.11A1 1 0 0 1 19 4v16a1 1 0 0 1-1.581.814L12 16.944V7.056l5.419-3.87a1 1 0 0 1 1.039-.076ZM22 12c0 1.48-.804 2.773-2 3.465v-6.93c1.196.692 2 1.984 2 3.465ZM10 8H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6V8Zm0 9H5v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Announcement Management</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/visitor-management']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M4.998 7.78C6.729 6.345 9.198 5 12 5c2.802 0 5.27 1.345 7.002 2.78a12.713 12.713 0 0 1 2.096 2.183c.253.344.465.682.618.997.14.286.284.658.284 1.04s-.145.754-.284 1.04a6.6 6.6 0 0 1-.618.997 12.712 12.712 0 0 1-2.096 2.183C17.271 17.655 14.802 19 12 19c-2.802 0-5.27-1.345-7.002-2.78a12.712 12.712 0 0 1-2.096-2.183 6.6 6.6 0 0 1-.618-.997C2.144 12.754 2 12.382 2 12s.145-.754.284-1.04c.153-.315.365-.653.618-.997A12.714 12.714 0 0 1 4.998 7.78ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Visitor Management</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/banner-management']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm4.996 2a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm-4.004 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm-4.004 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 14a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Banner Management</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/audio-announcement']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg version="1.1" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" id="Layer_1" x="0" y="0"
                     viewBox="0 0 32 32" style="enable-background:new 0 0 32 32" xml:space="preserve"
                     fill="currentColor">
                     <style></style>
                     <path
                        d="M16 27.308c-5.514 0-10-4.487-10-10a1 1 0 1 1 2 0c0 4.41 3.589 8 8 8s8-3.59 8-8a1 1 0 1 1 2 0c0 5.513-4.486 10-10 10z" />
                     <path
                        d="M16 24c-3.309 0-6-2.691-6-6V6c0-3.309 2.691-6 6-6s6 2.691 6 6v12c0 3.309-2.691 6-6 6zm0-22c-2.206 0-4 1.794-4 4v12c0 2.206 1.794 4 4 4s4-1.794 4-4V6c0-2.206-1.794-4-4-4zM21 32H11a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2z" />
                     <path
                        d="M16 32a1 1 0 0 1-1-1v-4.692a1 1 0 1 1 2 0V31a1 1 0 0 1-1 1zM21 8.938h-3.246a1 1 0 1 1 0-2H21a1 1 0 1 1 0 2zM21 13h-3.246a1 1 0 1 1 0-2H21a1 1 0 1 1 0 2zM21 17.063h-3.246a1 1 0 1 1 0-2H21a1 1 0 1 1 0 2zM14.246 8.938H11a1 1 0 1 1 0-2h3.246a1 1 0 1 1 0 2zM14.246 13H11a1 1 0 1 1 0-2h3.246a1 1 0 1 1 0 2zM14.246 17.063H11a1 1 0 1 1 0-2h3.246a1 1 0 1 1 0 2z" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Audio Announcement</span>
            </a>
         </li>

         <li>
            <button (click)="toggleSubMenu()" [ngClass]="isSubMenuOpen ? 'bg-gray-100' : ''"
               class="flex items-center w-full p-2 text-base text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 justify-between">
               <div class="flex items-center min-w-0">
                  <span
                     class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                     <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="currentColor" viewBox="0 0 24 24">
                        <path
                           d="M20 14h-2.722L11 20.278a5.511 5.511 0 0 1-.9.722H20a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM9 3H4a1 1 0 0 0-1 1v13.5a3.5 3.5 0 1 0 7 0V4a1 1 0 0 0-1-1ZM6.5 18.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM19.132 7.9 15.6 4.368a1 1 0 0 0-1.414 0L12 6.55v9.9l7.132-7.132a1 1 0 0 0 0-1.418Z" />
                     </svg>
                  </span>
                  <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Bulk Transfer</span>
               </div>
               <svg [class.rotate-180]="isSubMenuOpen"
                  class="w-4 h-4 shrink-0 transition-transform duration-200 text-gray-500" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
               </svg>
            </button>

            <!-- Submenu -->
            <ul *ngIf="isSubMenuOpen" class="mt-1 ml-4 space-y-1 border-l border-gray-200 pl-3">
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/usdt-transfer']"
                     class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M4 7h13M4 7l4-4M4 7l4 4M20 17H7m13 0l-4-4m4 4l-4 4" />
                     </svg>
                     <span>Transfer & Details</span>
                  </a>
               </li>
               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/usdt-transaction-history']"
                     class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M9 12l2 2l4 -4M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10z" />
                     </svg>
                     <span>Successful Transactions</span>
                  </a>
               </li>

               <li>
                  <a routerLinkActive="active-link" [routerLink]="['/usdt-failed-transaction-history']"
                     class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition duration-75 hover:bg-gray-100">
                     <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M15 9l-6 6m0-6l6 6M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10z" />
                     </svg>
                     <span>Failed Transactions</span>
                  </a>
               </li>
            </ul>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/tester-management']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path
                        d="M6 2c-1.10457 0-2 .89543-2 2v4c0 .55228.44772 1 1 1s1-.44772 1-1V4h12v7h-2c-.5523 0-1 .4477-1 1v2h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h5c.5523 0 1-.4477 1-1V3.85714C20 2.98529 19.3667 2 18.268 2H6Z" />
                     <path
                        d="M6 11.5C6 9.567 7.567 8 9.5 8S13 9.567 13 11.5 11.433 15 9.5 15 6 13.433 6 11.5ZM4 20c0-2.2091 1.79086-4 4-4h3c2.2091 0 4 1.7909 4 4 0 1.1046-.8954 2-2 2H6c-1.10457 0-2-.8954-2-2Z" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Testers Management</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/referral-management']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M12 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-1.5 8a4 4 0 0 0-4 4 2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-3Zm6.82-3.096a5.51 5.51 0 0 0-2.797-6.293 3.5 3.5 0 1 1 2.796 6.292ZM19.5 18h.5a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-1.1a5.503 5.503 0 0 1-.471.762A5.998 5.998 0 0 1 19.5 18ZM4 7.5a3.5 3.5 0 0 1 5.477-2.889 5.5 5.5 0 0 0-2.796 6.293A3.501 3.501 0 0 1 4 7.5ZM7.1 12H6a4 4 0 0 0-4 4 2 2 0 0 0 2 2h.5a5.998 5.998 0 0 1 3.071-5.238A5.505 5.505 0 0 1 7.1 12Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Testers Referral Management</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/referral-timer']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">Referral Management Timer</span>
            </a>
         </li>

         <li>
            <a routerLinkActive="active-link" [routerLink]="['/news-letter-management']"
               class="flex items-center p-2 text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group">
               <span class="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-100 text-gray-800 shrink-0">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" viewBox="0 0 24 24">
                     <path fill-rule="evenodd"
                        d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Zm-1 9a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm2-5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 4a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z"
                        clip-rule="evenodd" />
                  </svg>
               </span>
               <span class="ms-3 flex-1 min-w-0 text-left leading-snug">News Letter Management</span>
            </a>
         </li>
      </ul>
   </div>
</aside>
